import { render, staticRenderFns } from "./PdpVelocityPoints.vue?vue&type=template&id=17497dfc&"
import script from "./PdpVelocityPoints.vue?vue&type=script&lang=js&"
export * from "./PdpVelocityPoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgVelocityLogo: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/svg/VelocityLogo.vue').default})
